export const PAYMENT_VERIFICATION_REQUEST = "PAYMENT_VERIFICATION_REQUEST";
export const PAYMENT_VERIFICATION_SUCCESS = "PAYMENT_VERIFICATION_SUCCESS";
export const PAYMENT_VERIFICATION_FAIL = "PAYMENT_VERIFICATION_FAIL";
